import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const formControl = ({
  spacing,
}: InternalThemeConfig): ComponentsOverrides<Theme>["MuiFormControl"] => ({
  root: {
    minWidth: spacing(10),
    minHeight: spacing(8.5),
    margin: undefined,
    padding: undefined,
    border: undefined,
    verticalAlign: undefined,
  },
});

export default formControl;
